import React, { useState } from "react";
import { Container, Carousel } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Project/Project.css";
import Scribe from "../../assets/image/scribe.png";
import Ecommerce from "../../assets/image/Ecommerce.png";
import todolist from "../../assets/image/To Do List App.png";

const projects = [
  {
    id: 1,
    name: "Scribe - The Social Media Blog Page",
    description:
      "This project i have create for Angular course and it a use for multiple user which can add update and delete their blog",
    image: Scribe,
  },
  {
    id: 2,
    name: "E-commerce - The Cloths Ecommerce website",
    description:
      "This project i have create for React project and it is use for multiple and different type of cloths for all the varatiey ofpeople including kids ",
    image: Ecommerce,
  },
  {
    id: 3,
    name: "To-Do-List",
    description:
      "This is a basic project i created just by using HTML CSS and Javascript",
    image: todolist,
  },
];

const ProjectsPage = () => {
  return (
    <Container id="project" fluid className="contact bg-dark py-1  text-white">
      <h1 className="display-1 text-center mb-5 font-bold font-Georgia">
        My Projects
      </h1>
      <Carousel>
        {projects.map((project) => (
          <Carousel.Item key={project.id}>
            <div className="project-card">
              <img
                src={project.image}
                alt={project.name}
                className="d-block w-100 project-image"
              />
              <div className="overlay">
                <h5>{project.name}</h5>
                <p>{project.description}</p>
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </Container>
  );
};

export default ProjectsPage;
